import FiltersQuery from './FiltersQuery'

class FiltersForm {
  form: HTMLFormElement

  constructor(form: HTMLFormElement) {
    this.form = form
    this.handleClearFormButton()
  }

  private handleClearFormButton() {
    const inputs = this.form.querySelectorAll('input, select') as NodeListOf<HTMLInputElement>

    const button = this.form.querySelector('.filters-clear-button')
    const FiltersQueryInstance = new FiltersQuery(this.form)

    if (button) {
      button.addEventListener('click', () => {
        this.form.reset()

        inputs.forEach(checkbox => checkbox.removeAttribute('checked'))

        FiltersQueryInstance.getPosts()
      })
    }
  }
}

export default FiltersForm
